import * as React from "react";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import "./styles.css";

export default function Variants() {
  return (
    <React.Fragment>
      <Stack spacing={1} className="rocket">
        <Skeleton variant="circular" width={70} height={70} />
        <Skeleton variant="rectangular" width={140} height={30} />
        <Skeleton variant="rectangular" width={140} height={30} />
      </Stack>

      <Stack
        spacing={1}
        style={{
          margin: "25px 5px",
        }}
      >
        <Skeleton variant="rounded" width={"100%"} height={60} />
      </Stack>
    </React.Fragment>
  );
}
